<template>
  <div>
    <header class="fixed-top align-items-center">
      <div class="container-fluid">
        <div class="row header-height align-items-center">
          <div class="col-4 lh-47">
            <span class="action-icon" @click="toggleMenu()">
              <i class="lni lni-menu m-0"></i>
            </span>

            <div class="d-inline-block grml-2 grml-md-7">
              <b-dropdown
                class="dropdown-menu-left"
                left
                variant="empty"
                toggle-class="p-0 m-0"
                menu-class="bg-white "
                no-caret
              >
                <template slot="button-content">
                  <div>
                    <div
                      class="text-body lead float-left grml-3 grml-md-5"
                    >
                  
                    <div class="d-none d-md-inline-block font-weight-500 mt-n5">
                      {{ companies.filter( company => company.id==current_company_id)[0].name }}
                    </div>       

                    <i class="lni lni-reload text-primary  ml-2" v-if="companies.length > 1"></i>
                    </div>
                  </div>
                </template>

              
                  <b-dropdown-item @click="changeCompany(company.id)" class="l-h-1"
                    v-for="company in companies" :key="company.id">
                    <span>
                      <small class="text-muted">{{ company.code }}</small><br>
                      {{ company.name }}
                    </span>                    
                  </b-dropdown-item>  
              

              </b-dropdown>
            </div>
          </div>

          <div class="col-8 text-right">
            <!-- User Profile -->
            <div class="float-right lh-47">
              <div class="d-inline-block">
                <b-dropdown
                  class="dropdown-menu-right l-h-2"
                  right
                  variant="empty"
                  toggle-class="p-0 m-0"
                  menu-class="bg-white "
                  no-caret
                >
                  <template slot="button-content">
                    <div class="lh-47">
                      <div class="profile-pic-con grh-9 grw-9 float-left">
                        <v-lazy-image v-if="user.image" :alt="user.name" :src="user.image" />
                      </div>

                  

                      <div
                        class="text-body text-left font-weight-600 float-left grml-6 d-none d-md-block pt-2"
                        style="line-height:1"
                      >
                        {{ user.name }}<br>
                        <small class="text-muted font-size-11">{{ user.email }}</small>
                      </div>
                    </div>
                  </template>

                  <b-dropdown-item :to="{ name: 'my-account' }">My Account</b-dropdown-item>

                  <b-dropdown-divider />
                  <b-dropdown-item @click="logout">Sign out</b-dropdown-item>
                  <b-dropdown-item @click="logoutAll">Sign out All Devices</b-dropdown-item>
                </b-dropdown>
              </div>
            </div>

            <!-- Action Icons -->
            <div class="float-right my-auto lh-47">
              <i
                class="lni lni-zoom-in grmr-3 d-none d-lg-inline pointer action-icon"
                @click="toggleFullscreen()"
              ></i>

              <i
                class="lni lni-paint-bucket grmr-3  pointer action-icon"
                @click="toggleColorMode()"
              ></i>

               <i
                class="lni lni-text-format grmr-3  pointer action-icon"
                @click="toggleFontMode()"
              ></i>

              <!-- <i class="lni lni-bullhorn text-black-50 grmr-9"></i> -->

              <div class="position-relative d-inline-block grmr-3 grmr-md-9">
                <b-dropdown
                  @hide="markNotificationsAsRead()"
                  variant="empty"
                  size="sm"
                  right
                  toggle-class="text-black-50 p-0 m-0"
                  menu-class="position-absolute mt-3 notificationDropdown bg-white"
                  no-caret
                >
                  <template slot="button-content">
                    <i
                      class="lni lni-bullhorn  action-icon"
                      style="margin-top:-8px;"
                    />

                    <span
                      v-if="notifications.filter(x => x.read_at === null).length > 0"
                      class="count blink-me"
                    >
                      {{
                      notifications.filter(x => x.read_at === null).length
                      }}
                    </span>

                    <!-- <span
                      v-if="notifications.filter(x => x.read_at === null).length == 0"
                      class="count bg-success"
                    >
                      <i class="lni lni-checkmark"></i>
                    </span>-->
                  </template>

                  <vue-custom-scrollbar
                    class="p-3"
                    style="height:320px; width:260px;line-height:1.1"
                  >
                    <b-button
                      :to="{ name: 'notifications' }"
                      variant="primary"
                      size="xs"
                      class="mb-2 btn-block"
                    >View Notifications</b-button>

                    <div
                      class="my-1 pb-1 border-bottom"
                      v-for="notification in notifications"
                      :key="notification.id"
                    >
                      <small class="text-body">{{ notification.data.message }}</small>
                      <br />
                      <small class="text-muted py-2">{{ notification.when }}</small>
                    </div>
                  </vue-custom-scrollbar>
                </b-dropdown>
              </div>
            </div>
          </div>
        </div>

        <!-- breadcrumbs on mobile -->
        <!-- <div class="row d-md-none">
          <div class="col">
            <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
          </div>           
        </div>-->
      </div>
    </header>
  </div>
</template>

<script>
import store from "@/store";
import notificationRepo from "./../../api/repos/notificationRepo";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { mapActions } from 'vuex'

export default {  

  components: {
    vueCustomScrollbar,
  },
  data() {
    return {
      darkMode: false,
      smallFontMode: false,
      notifications: [],
      breadcrumbs: [],
    };
  },
  mounted() {
    this.getNotifications();
    window.setInterval(() => {
      this.getNotifications();
    }, 30000);

    this.breadcrumbs = this.$route.meta.breadcrumb;

    // check for active theme
    let htmlElement = document.documentElement;
    let theme = localStorage.getItem("theme");

    if (theme === "dark") {
      htmlElement.setAttribute("theme", "dark");
      this.darkMode=true
    } else {
      htmlElement.setAttribute("theme", "light");
      this.darkMode=false
    }


    let fontMode = localStorage.getItem("font");

    if (fontMode === "small") {
      htmlElement.setAttribute("font", "small");
      this.smallFontMode=true
    } else {
      htmlElement.setAttribute("font", "big");
      this.smallFontMode=false
    }
  },
  methods: {
    ...mapActions('user', ['refreshAuth']),

    toggleFullscreen() {
      if (
        (document.fullScreenElement && document.fullScreenElement !== null) ||
        (!document.mozFullScreen && !document.webkitIsFullScreen)
      ) {
        if (document.documentElement.requestFullScreen) {
          document.documentElement.requestFullScreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) {
          document.documentElement.webkitRequestFullScreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    toggleColorMode() {
      this.darkMode = !this.darkMode;
      // add/remove class to/from html tag
      let htmlElement = document.documentElement;

      if (this.darkMode) {
        localStorage.setItem("theme", "dark");
        htmlElement.setAttribute("theme", "dark");
      } else {
        localStorage.setItem("theme", "light");
        htmlElement.setAttribute("theme", "light");
      }
    },
    toggleFontMode() {
      this.smallFontMode = !this.smallFontMode;
      // add/remove class to/from html tag
      let htmlElement = document.documentElement;

      if (this.smallFontMode) {
        localStorage.setItem("font", "small");
        htmlElement.setAttribute("font", "small");
      } else {
        localStorage.setItem("font", "big");
        htmlElement.setAttribute("font", "big");
      }
    },
    toggleMenu() {
      if (this.$store.getters["menu/menuState"] == "open") {
        store.commit("menu/setMenuState", "close");
      } else {
        store.commit("menu/setMenuState", "open");
      }
    },
    async getNotifications() {
      if (localStorage.getItem("user") !== null) {
        try {
          let { data } = await notificationRepo.notifications();
          this.notifications = data.notifications.data.map((x) => {
            return { ...x, when: this.moment(x.created_at).fromNow() };
          });
          this.refreshAuth(data)
        } catch (error) {
          console.log(error);
        }
      }
    },

    logout() {
      this.$router.push({ name: "logout" });
    },

    logoutAll() {
      this.$router.push({ name: "logoutAll" });
    },

    changeCompany(id) {
      localStorage.setItem("current_company_id",id)
      store.commit("user/setCurrentCompanyId",id)
      window.location.href="/home"
    },

    async markNotificationsAsRead() {
      this.notifications = this.notifications.map((x) => {
        return { ...x, read_at: 1 };
      });
      try {
        await notificationRepo.update();
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    companies() {
      return this.$store.state.user.companies;
    },
    current_company_id() {
      return this.$store.state.user.current_company_id;
    },
  },
  watch: {
    $route() {
      this.breadcrumbs = this.$route.meta.breadcrumb;
    },
  },
};
</script>

<style lang="scss" scoped>
//@import "./../../assets/css/theme_colors";

.header-height{
  height: 120px;
}

header {
  //border-bottom-left-radius: 44px;
  //border-bottom-right-radius: 44px;
  top: 0;

  background-color: var(--bg-white);
  // border-left: solid 3px var(--app-background-color);
  // border-right: solid 3px var(--app-background-color);
  // border-bottom: solid 6px var(--app-background-color);

  //box-shadow: 0 1px 15px rgba(0,0,0,.04), 0 1px 6px rgba(0,0,0,.04);



  .profile-pic-con {
    background: var(--container-border);
    border-radius: 0;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .search-con {
    border-radius: 8px;
    max-width: 300px;
    border: none;
    background: var(--container-border);
    line-height: 47px;
  }
  .search-con-input {
    height: 67px;
    margin-left: 5px;
    border: none;
    background: var(--container-border);
  }
  .lh-47 {
    line-height: 47px;
  }
  .count {
    top: -12px;
    left: 10px;
    color: white;
    position: absolute;
    background: crimson;
    border-radius: 4px;
    padding: 2px 4px;
    font-size: 9px;
  }

  .btn-menu {
    background: var(--primary);
    color: #fff;
    border-radius: 12px;
  }

  .action-icon {
    //background: var(--app-background-color);
    padding: 8px;
    border-radius: 12px;
    color: var(--primary);
    font-size: 23px;
  }
}
</style>